var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"400px"}},[_c('GridVx',{ref:"agGrid",staticClass:"agGrid",attrs:{"dom-layout":"scroll","columns":_vm.columns,"rows":_vm.bookingDetailStore.sub_booking_group_surcharges,"row-selection":"single"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }